import { render, staticRenderFns } from "./selectPersonas.vue?vue&type=template&id=1fe344ec&scoped=true&"
import script from "./selectPersonas.vue?vue&type=script&lang=js&"
export * from "./selectPersonas.vue?vue&type=script&lang=js&"
import style0 from "./selectPersonas.vue?vue&type=style&index=0&id=1fe344ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe344ec",
  null
  
)

export default component.exports